'use es6';

import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PortalIdParser from 'PortalIdParser';
import { PlayerMessageTypes } from '../../constants/video';
import { getEmbedIframeDomain, getEmbedIframeUrl, stringifyQueryParams } from '../../utils/video';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "VideoPlayer__StyledWrapper",
  componentId: "sc-144g7ty-0"
})(["background-color:", ";line-height:0;"], props => props.backgroundColor);
const StyledIframe = styled.iframe.withConfig({
  displayName: "VideoPlayer__StyledIframe",
  componentId: "sc-144g7ty-1"
})(["width:100%;border:0 none;"]);
const VideoPlayer = ({
  portalId = PortalIdParser.get(),
  video = {},
  maxHeight,
  backgroundColor,
  conversionAsset,
  hiddenControls,
  currentTime
}) => {
  const iframeRef = useRef(null);
  const hashParams = {
    hsvid: 'rich-text-lib-preview',
    conversionAsset: JSON.stringify(conversionAsset)
  };
  const iframeSrc = `${getEmbedIframeUrl(portalId, video.videoId, {
    parentOrigin: window.location.origin,
    renderContext: 'rich-text-lib'
  })}#${stringifyQueryParams(hashParams)}`;
  useEffect(() => {
    if (iframeRef.current && currentTime) {
      iframeRef.current.contentWindow.postMessage({
        type: PlayerMessageTypes.SET_CURRENT_TIME,
        currentTime
      }, getEmbedIframeDomain());
    }
  }, [currentTime]);
  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage({
        type: PlayerMessageTypes.UPDATE_DISPLAY_OPTIONS,
        payload: {
          hiddenControls,
          conversionAsset
        }
      }, getEmbedIframeDomain());
    }
  }, [hiddenControls, conversionAsset]);
  return /*#__PURE__*/_jsx(StyledWrapper, {
    className: "hs-video-player",
    backgroundColor: backgroundColor,
    children: /*#__PURE__*/_jsx(StyledIframe, {
      ref: iframeRef,
      src: iframeSrc,
      height: maxHeight,
      referrerPolicy: "origin",
      sandbox: "allow-forms allow-scripts allow-same-origin allow-popups",
      allow: "fullscreen;"
    })
  });
};
VideoPlayer.propTypes = {
  id: PropTypes.number,
  portalId: PropTypes.number,
  video: PropTypes.object,
  maxHeight: PropTypes.number,
  backgroundColor: PropTypes.string,
  conversionAsset: PropTypes.object,
  currentTime: PropTypes.number,
  hiddenControls: PropTypes.bool
};
export default VideoPlayer;